import {ACTION_GET_ACT_INFO ,HIDE_COMP} from '../constant/eventbus'
import {get_act_stat} from '../api'
import {isUndefined} from '../tools/typeof'
import {error_event} from '../tools/mgtv/analysis'
import setTitle from '../tools/set-title'
import {setShare,disable_share} from '../tools/mgtv/share'
import { processComp} from '../tools/tpl'


export default {
  install: function (EventBus) {
    EventBus.$on(ACTION_GET_ACT_INFO, () => {

      //获取活动状态
      get_act_stat().then(res => {
        EventBus.$set(EventBus, 'needRemoveLoading', true)
        if (!res) {
          if (!gact.auto_login) {
            window.$toast('获取活动状态失败');
          } else {
            //自动登陆时会跳转走，会导致这个接口发生错误。让这个消息晚一点出现。
            setTimeout(() => {
              window.$toast('获取活动状态失败');
            }, 1500);
          }
          return;
        }
        if (res.ret === 0 && !isUndefined(res.data.is_start)) {
          EventBus.$set(EventBus.act, 'act_stat', res.data.is_start);
          EventBus.$set(EventBus.act, 'end_time', res.data.end_time);
          EventBus.$set(EventBus.act, 'start_time', res.data.start_time);

          if (res.data.is_start === 2) {
            window.$toast("活动已结束");
          } else if (res.data.is_start === 0) {
            window.$toast("活动即将开始,敬请期待");
          }

          //活动中文名称
          window.rootdata.act_name_chn = res.data.act_name_chn;

          const tpl = res.data.tpl;
          if (!tpl) {
            window.$toast('无页面配置信息');
            return;
          }

          if(!tpl.tpl_page){
            tpl.tpl_page = {}
          }

          if (!tpl.comps) {
            tpl.comps = []
          }

          //检查UA_LIMIT
          // let ua_limit = tpl.page.ua_limit;
          // if(ua_limit){
          //   const ua = window.navigator.userAgent;
          //   ua_limit = ua_limit.split('|');
          //   let is_ua_invalid = true
          //   ua_limit.forEach(item=>{
          //     if(ua.indexOf(item) >= 0){
          //       is_ua_invalid = false
          //     }
          //   })
          //   if(is_ua_invalid){
          //     window.$bus.invalid_message = tpl.page.ua_limit_tip || '本页面禁止在当前环境中打开';
          //   }
          // }


          //检查BASE_URL，防止被恶意使用低版本的URL
          // const base_url = tpl.page.base_url;
          // if(base_url){
          //   const target_url = base_url + window.location.search;
          //  if(window.location.href !== target_url){
          //    if(['127.0.0.1','t8080.mgtv.com','t8081.mgtv.com','t8082.mgtv.com','t8083.mgtv.com'].indexOf(window.location.hostname) === -1){
          //      window.location.href = target_url;
          //    }
          //  }
          // }

          tpl.comps.forEach(comp => {
            processComp(comp);
          });

          // console.log(tpl);

          window.$bus.tpl = tpl;
          const title = tpl.tpl_page.title;
          if (title) {
            if(gact.is_test){
              setTitle('(预览)'+title);
            }else{
              setTitle(title);
            }
          }

          if(tpl.tpl_page.disable_share){
            disable_share();
          }else{
            let share_title = tpl.tpl_page.share_title;
            let share_desc = tpl.tpl_page.share_desc;
            let share_img = tpl.tpl_page.share_img;
            if (share_title && share_img) {
              setShare({
                title: share_title,
                desc: share_desc,
                img: share_img,
              })
            }
          }

          // setTimeout(()=>{
          //   window.$loading_dialog.close();
          // },250);

        } else {
          window.$toast('获取活动状态失败');
        }
      }).catch(e => {
        error_event(e)
      })
    });


    //隐藏模块,当轮播、滚动图文、多行图文中没有内容时，直接隐藏模块
    EventBus.$on(HIDE_COMP, (comp_name) => {
        const comps = window.$bus.tpl.comps;
        for(let i = 0; i < comps.length; i++){
          if(comps[i].act_name === comp_name){
            comps[i].hide = true;
            break;
          }
        }

    });



  }
}





